import { PrivateBankingServiceDefinitionId, ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { Active } from 'types';
import { isWealthPlanningServiceAgreementProperties } from '../../../../productSpecificProperties';

type ExternalServicingUsersProductId =
  | typeof PrivateBankingServiceDefinitionId.WealthPlanningServices
  | typeof PrivateBankingServiceDefinitionId.ActiveReferralWp;

export type ExternalServicingUsersProductConfig = {
  titleKey: string;
  width: string;
  size: 'small' | 'large';
  configurationSectionProduct: 'wealthplanning' | 'activeReferralWp';
  activeCloseBodyTextKey: string;
  getCloseDisabledReasonKey: (agreement: ServiceAgreementV2) => string | null;
};

const getActiveReferralWpCloseDisabledReasonKey = (agreement: ServiceAgreementV2): string | null => {
  if (agreement.canBeClosed) return null;
  return agreement.agreementStatus === Active.ACTIVE
    ? 'pb.configureproductmodal.activeReferralWp.active.close.tooltip'
    : 'pb.configureproductmodal.activeReferralWp.close.noPermission.tooltip';
};

const getWealthPlanningCloseDisabledReasonKey = (agreement: ServiceAgreementV2): string | null => {
  if (agreement.agreementStatus !== Active.ACTIVE) return null;
  const properties = isWealthPlanningServiceAgreementProperties(agreement.productSpecificProperties)
    ? agreement.productSpecificProperties
    : undefined;
  return properties?.canCloseProduct === true
    ? null
    : 'pb.configureproductmodal.wealthplanning.active.close.cdsonly.tooltip';
};

export const externalServicingUsersProductConfigs = {
  [PrivateBankingServiceDefinitionId.WealthPlanningServices]: {
    titleKey: 'pb.configureproductmodal.wealthplanning.title',
    width: '540px',
    size: 'small',
    configurationSectionProduct: 'wealthplanning',
    activeCloseBodyTextKey: 'pb.deleteproductmodal.closeproduct.wealthplanning.active',
    getCloseDisabledReasonKey: getWealthPlanningCloseDisabledReasonKey,
  },
  [PrivateBankingServiceDefinitionId.ActiveReferralWp]: {
    titleKey: 'pb.configureproductmodal.activeReferralWp.title',
    width: '900px',
    size: 'large',
    configurationSectionProduct: 'activeReferralWp',
    activeCloseBodyTextKey: 'pb.deleteproductmodal.closeproduct.activereferralwp.active',
    getCloseDisabledReasonKey: getActiveReferralWpCloseDisabledReasonKey,
  },
} satisfies Record<ExternalServicingUsersProductId, ExternalServicingUsersProductConfig>;

export const getExternalServicingUsersProductConfig = (
  serviceDefinitionId: PrivateBankingServiceDefinitionId | undefined,
): ExternalServicingUsersProductConfig => {
  const config = externalServicingUsersProductConfigs[serviceDefinitionId as ExternalServicingUsersProductId];
  if (!config) {
    throw new Error(`No external servicing users configuration for ${serviceDefinitionId}`);
  }
  return config;
};
